/*
 *
 * Groups reducer
 *
 */
import produce from 'immer';
import { LOAD_GROUPS_REQUEST, LOAD_GROUPS_SUCCESS, LOAD_GROUPS_FAILURE, UPDATE_GROUPS_SUCCESS, UPDATE_GROUPS_REQUEST, UPDATE_GROUPS_FAILURE, DELETE_GROUP_REQUEST, DELETE_GROUP_SUCCESS, DELETE_GROUP_FAILURE, } from './constants';
export var initialState = {
    groups: [],
    meta: {},
    loading: false,
    error: false,
    updated: false,
    deleting: false,
    delete_error: false,
};
function groupsReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        switch (action.type) {
            case LOAD_GROUPS_REQUEST:
                state.loading = true;
                state.error = false;
                break;
            case LOAD_GROUPS_SUCCESS:
                state.groups = action.groups;
                state.meta = action.meta;
                state.loading = false;
                state.error = false;
                state.updated = false;
                break;
            case LOAD_GROUPS_FAILURE:
                state.loading = false;
                state.error = true;
                break;
            case UPDATE_GROUPS_REQUEST:
                state.loading = true;
                state.error = false;
                break;
            case UPDATE_GROUPS_SUCCESS:
                state.updated = true;
                state.loading = false;
                state.error = false;
                break;
            case UPDATE_GROUPS_FAILURE:
                state.loading = false;
                state.error = true;
                break;
            case DELETE_GROUP_REQUEST:
                state.deleting = true;
                state.delete_error = false;
                break;
            case DELETE_GROUP_SUCCESS:
                state.deleting = false;
                state.delete_error = false;
                state.groups = state.groups.filter(function (g) { return g.id !== action.groupId; });
                break;
            case DELETE_GROUP_FAILURE:
                state.deleting = false;
                state.delete_error = true;
                break;
            default:
        }
    });
}
export default groupsReducer;
